import React from 'react';
import { FormFieldProps } from '../../../types';
import './FormField.css';

const FormField: React.FC<FormFieldProps> = ({
  id,
  label,
  type = 'text',
  value,
  onChange,
  placeholder,
  required = false,
  options = [],
  error,
  disabled = false,
  className = '',
  min,
  step
}) => {
  const fieldClasses = `form-field ${error ? 'has-error' : ''} ${className}`.trim();
  const inputClasses = `form-field-input ${error ? 'input-error' : ''}`.trim();
  
  const renderInput = () => {
    switch (type) {
      case 'textarea':
        return (
          <textarea
            id={id}
            value={value}
            onChange={onChange as React.ChangeEventHandler<HTMLTextAreaElement>}
            placeholder={placeholder}
            required={required}
            disabled={disabled}
            className={inputClasses}
            rows={4}
          />
        );
        
      case 'select':
        return (
          <select
            id={id}
            value={value}
            onChange={onChange as React.ChangeEventHandler<HTMLSelectElement>}
            required={required}
            disabled={disabled}
            className={inputClasses}
          >
            <option value="" disabled>{placeholder || 'Select an option'}</option>
            {options.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        );
        
      default:
        return (
          <input
            id={id}
            type={type}
            value={value}
            onChange={onChange as React.ChangeEventHandler<HTMLInputElement>}
            placeholder={placeholder}
            required={required}
            disabled={disabled}
            className={inputClasses}
            min={min}
            step={step}
          />
        );
    }
  };
  
  return (
    <div className={fieldClasses}>
      <label htmlFor={id} className="form-field-label">
        {label}
        {required && <span className="required-indicator">*</span>}
      </label>
      
      {renderInput()}
      
      {error && <div className="form-field-error">{error}</div>}
    </div>
  );
};

export default FormField;
